(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('NationalBrokerageDialogController', NationalBrokerageDialogController);

    NationalBrokerageDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'NationalBrokerage'];

    function NationalBrokerageDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, NationalBrokerage) {
        var vm = this;

        vm.nationalBrokerage = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.nationalBrokerage.id !== null) {
                NationalBrokerage.update(vm.nationalBrokerage, onSaveSuccess, onSaveError);
            } else {
                NationalBrokerage.save(vm.nationalBrokerage, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('valueconnectApp:nationalBrokerageUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
